import { render, staticRenderFns } from "./country_grouped.vue?vue&type=template&id=2f2b6ec8&scoped=true"
import script from "./country_grouped.vue?vue&type=script&lang=js"
export * from "./country_grouped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b6ec8",
  null
  
)

export default component.exports